<app-badge
  *ngIf="status"
  size="s"
  [backgroundColor]="status.hex_color"
  [color]="status.text_color || 'var(--primary-w-white)'"
  [text]="status.label | translate | uppercase"
></app-badge>
